// This function allow to reference async chunks and chunks that the entrypoint depends on
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"636":"8f974a43fa21ae1e","1202":"3ba697564359d0ca"}[chunkId] + ".css";
};